import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
declare let $: any;
interface incub {
  id: string;
  incubatorName: string;
}
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css'],
  animations: [
    trigger('flip', [
      state('front', style({ transform: 'rotateY(0deg)' })),
      state('back', style({ transform: 'rotateY(180deg)' })),
      transition('* => *', animate('400ms ease')),
    ]),
  ],
})
export class HomePageComponent implements OnInit {
  @ViewChild('contentToHide') contentToHide: ElementRef;
  @HostListener('document:click', ['$event'])
  incubationCenters;
  incubationSpace;
  sectorsFocused;
  startupsIncubated;
  private gallerylistApi = environment.url + environment.galleryList;
  private listApi = environment.url + environment.eventList;
  private bloglistApi = environment.url + environment.blogList;
  private nameListApi = environment.url + environment.incubatorNameList;
  private saveForm = environment.url + environment.submitFormList;
  private mapGetApi = environment.url + environment.mapGet;
  private homelistApi = environment.url + environment.homelist;
  panelOpenState = false;
  hideOnInteraction: boolean = false;
  showOnLoad: boolean = false;
  incubatorForm: FormGroup;
  options = [
    'Incubation Supports',
    'Workspace / Technical facilities',
    'Investment',
    'Mentorship',
    'Others',
  ];

  isHidden = false;
  isShow = false;

  imageStates: boolean[] = [false, false, false];
  flippedDivId: number | null = null;
  /**
   * Creates a new instance of the HomePageComponent.
   * @param getdata The service to get the data.
   * @param makeapi The service to make the API calls.
   * @param notify The service to notify the user.
   * @param fb The form builder.
   */
  constructor(
    private getdata: ValueService,
    private makeapi: ApiService,
    private notify: NotifyService,
    private fb: FormBuilder
  ) {
    /**
     * Creates the form for the incubator.
     * The form has the following fields:
     * - name: The name of the incubator.
     * - startupName: The name of the startup.
     * - email: The email address of the incubator.
     * - phone: The phone number of the incubator.
     * - incubator: The type of incubator.
     * - purpose: The purpose of the incubator.
     * - message: The message for the incubator.
     */
    this.incubatorForm = this.fb.group({
      name: ['', [Validators.required]],
      startupName: [''],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      incubator: ['', [Validators.required]],
      purpose: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
  }
  get add() {
    return this.incubatorForm.controls;
  }
  flippedIndex: number = 0;
  currentIndex = 0;

  /**
   * Initializes the component.
   * Calls the galleryList() function to fetch the list of galleries from the API.
   * Hides the loader and sets the visibility of the source to true.
   */
  ngOnInit(): void {
    this.showOnLoad = true;
    this.getdata.isVisibleSource.next(true);
    this.incubatorNameApi();
    this.galleryList();
    // Initialize tooltips
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    // Initialize map
    this.map();
    // Initialize counter
    $('.counter-value').each(function () {
      let t = $(this),
        n = t.attr('data-count');
      // Animate the counter value
      $({ countNum: t.text() }).animate(
        { countNum: n },
        {
          duration: 3e3,
          easing: 'swing',
          step: function () {
            t.text(Math.floor(this.countNum));
          },
          complete: function () {
            t.text(this.countNum);
          },
        }
      );
    });
  }
  /**
   * Clears the form by resetting all form controls to their initial values.
   */
  clearForm() {
    // Reset the incubator form
    this.incubatorForm.reset();
  }
  /**
   * Flips to the next container by updating the currentIndex.
   * This method cycles through indices 0 to 2 in a loop.
   */
  flipToNextContainer(): void {
    // Increment the current index and wrap around using modulo
    this.currentIndex = (this.currentIndex + 1) % 3;
  }
  /**
   * Retrieves the list of incubators from the server.
   * The list of incubators is saved in the `incubatorNameList` property.
   * The `filterIncubetor` method is called to set the initial value of the
   * incubator name select.
   */
  incubatorNameApi() {
    /**
     * Make a post request to the incubator name list api.
     */
    this.makeapi
      .method(this.nameListApi, '', 'postunauth')
      .subscribe((data) => {
        /**
         * Save the list of incubators
         */
        this.incubatorNameList = data;
        /**
         * Set the initial value of the incubator name select
         */
        this.filterIncubetor();
      });
  }

  // blog code
  disBlogList = [];
  blogBoolean = false;
  /**
   * This method fetches the list of blogs from the API.
   * It requests the API with the required parameters and subscribes to the response.
   * If the response contains data, it updates the component data and initializes the blog slider.
   * If the response does not contain data, it sets the blogBoolean flag to true.
   * @returns An observable containing the response from the API.
   */
  blogListApi() {
    let req = {
      listSize: 12,
      pageNumber: 1,
    };
    return this.makeapi
      .method(this.bloglistApi, req, 'postunauth')
      .subscribe((data) => {
        if (data.responsemodelList != undefined) {
          // If the response contains data, update the component data and initialize the blog slider
          this.blogBoolean = false;
          this.disBlogList = data.responsemodelList;
          this.blog = this.disBlogList;
          this.totalBlogs = this.blog.length;
          this.blogPerPage = this.getBlogPerPage();
          this.initializeBlogSlider();
        } else {
          // If the response does not contain data, set the blogBoolean flag to true
          this.blogBoolean = true;
        }
      });
  }
  /**
   * Encodes the blog ID and stores it for blog details retrieval.
   * @param id - The ID of the blog to retrieve details for.
   */
  blogGet(id) {
    this.getdata.blogDetailsId(btoa(id));
  }
  blog = [];
  totalBlogs: number;
  currentBlogPage: number = 1;
  pageBlogPosition: string = '0%';
  blogPerPage: number;
  totalBlogPages: number;
  overflowBlogWidth: string;
  BlogWidth: string;
  blogContainerWidth: number;
  @ViewChild('blogContainer', { static: true, read: ElementRef })
  blogContainer: ElementRef;
  /**
   * This method is called when the window is resized.
   * It checks if the number of blogs and galleries per page has changed.
   * If so, it updates the total number of pages for both blogs and galleries,
   * and calculates the new position of the current page.
   * @returns Nothing.
   */
  @HostListener('window:resize')
  windowResize() {
    let newblogPerPage = this.getBlogPerPage();
    if (newblogPerPage != this.blogPerPage) {
      this.blogPerPage = newblogPerPage;
      this.initializeBlogSlider();
      if (this.currentBlogPage > this.totalBlogPages) {
        this.currentBlogPage = this.totalBlogPages;
        this.populateBlogPagePosition();
      }
    }
    let newgalleryPerPage = this.getGalleryPerPage();
    if (newgalleryPerPage != this.galleryPerPage) {
      this.galleryPerPage = newgalleryPerPage;
      this.initializeGallerySlider();
      if (this.currentGalleryPage > this.totalBlogPages) {
        this.currentGalleryPage = this.totalBlogPages;
        this.populateGalleryPagePosition();
      }
    }
  }
  /**
   * Initializes the blog slider.
   * Calculates the total number of pages, overflow width,
   * and width of each individual blog.
   * @returns Nothing.
   */
  initializeBlogSlider() {
    // Calculate the total number of pages
    this.totalBlogPages = Math.ceil(this.totalBlogs / this.blogPerPage);

    // Calculate the overflow width
    // The width of the overflow is the total number of pages multiplied by 100%
    // plus the total number of pages multiplied by 10px (for the margin between each page)
    this.overflowBlogWidth = `calc(${this.totalBlogPages * 100}% + ${
      this.totalBlogPages * 10
    }px)`;

    // Calculate the width of each individual blog
    // The width of each blog is the total number of pages multiplied by 100%
    // divided by the number of blogs per page
    // minus the number of blogs per page multiplied by 10px (for the margin between each blog)
    this.BlogWidth = `calc((${100 / this.totalBlogPages}% - ${
      this.blogPerPage * 10
    }px) / ${this.blogPerPage})`;
  }

  /**
   * Calculates the number of blogs that can be displayed per page
   * based on the width of the blog container.
   * @returns The number of blogs per page.
   */
  getBlogPerPage() {
    // Divide the width of the blog container by 300 to estimate the number of blogs
    return Math.floor(this.blogContainer.nativeElement.offsetWidth / 300);
  }

  /**
   * Changes the current blog page by the given incrementor.
   * @param incrementor The value to increment the current page by.
   * @returns Nothing.
   */
  changeBlogPage(incrementor: number) {
    this.currentBlogPage += incrementor;
    if (this.currentBlogPage < 1) {
      this.currentBlogPage = 1;
    } else if (this.currentBlogPage > this.totalBlogPages) {
      this.currentBlogPage = this.totalBlogPages;
    }
    this.populateBlogPagePosition();
  }

  /**
   * Populates the page position of the blog slider.
   * Calculates the correct left position of the blog slider based on the current page.
   * @returns The CSS left position string.
   */
  populateBlogPagePosition(): string {
    // Calculate the correct left position of the blog slider based on the current page
    return `calc(${-100 * (this.currentBlogPage - 1)}% - ${
      10 * (this.currentBlogPage - 1)
    }px)`;
  }
  // gallery code
  disList = [];
  galleryBoolean = false;
  /**
   * Fetches the list of galleries from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    // Request parameters for the API
    let req = {
      listSize: 12,
      pageNumber: 1,
    };

    // Call the API to fetch the list of galleries
    return this.makeapi
      .method(this.listApi, req, 'postunauth')
      .subscribe((data) => {
        // Check if the response contains any data
        if (data.responsemodelList != undefined) {
          // If there is data, update the component data
          this.galleryBoolean = false;
          this.disList = data.responsemodelList;
          this.gallery = this.disList;
          this.totalGallery = this.gallery.length;
          this.galleryPerPage = this.getGalleryPerPage();
          this.initializeGallerySlider();

          // Set the first carousel item to active
          $(document).ready(function () {
            $('.carosal0').addClass('active');
          });
        } else {
          // If there is no data, show the "No Data" message
          this.galleryBoolean = true;
        }
      });
  }
  gallery = [];
  totalGallery: number;
  currentGalleryPage: number = 1;
  pageGalleryPosition: string = '0%';
  galleryPerPage: number;
  galleryContainerWidth: number;
  totalGalleryPages: number;
  overflowGalleryWidth: string;
  GalleryWidth: string;
  @ViewChild('galleryContainer', { static: true, read: ElementRef })
  galleryContainer: ElementRef;
  /**
   * Initializes the gallery slider.
   * Calculates the width of the gallery slider, taking into account the number of galleries,
   * the width of the gallery container, and the spacing between galleries.
   * Updates the CSS variables to reflect the calculated widths.
   */
  initializeGallerySlider() {
    // Calculate the total number of pages in the gallery slider
    this.totalGalleryPages = Math.ceil(this.totalGallery / this.galleryPerPage);
    // Calculate the width of the overflow container
    this.overflowGalleryWidth = `calc(${this.totalGalleryPages * 100}% + ${
      this.totalGalleryPages * 10
    }px)`;
    // Calculate the width of each gallery item
    this.GalleryWidth = `calc((${100 / this.totalGalleryPages}% - ${
      this.galleryPerPage * 10
    }px) / ${this.galleryPerPage})`;
  }

  /**
   * Calculates the number of galleries to display per page based on the width of the gallery container.
   * @returns The number of galleries to display per page.
   */
  getGalleryPerPage(): number {
    return Math.floor(this.galleryContainer.nativeElement.offsetWidth / 300);
  }
  /**
   * Updates the position of the gallery page to reflect the current gallery page number.
   */

  /**
   * Changes the current gallery page by the specified incrementor and updates the gallery page position.
   * @param incrementor The number to increment or decrement the current gallery page by.
   */
  changeGalleryPage(incrementor) {
    // Update the current gallery page number
    this.currentGalleryPage += incrementor;
    // Update the position of the gallery page to reflect the new page number
    this.populateGalleryPagePosition();
  }

  /**
   * Sets the position of the gallery page based on the current page number.
   * @param incrementor The amount to increment the page number by.
   */
  populateGalleryPagePosition() {
    // Calculate the position of the gallery page based on the current page number
    // The position is calculated as a percentage of the total width of the gallery container
    // The percentage is then converted to a pixel value and subtracted from the total width
    // to get the correct position
    this.pageGalleryPosition = `calc(${
      -100 * (this.currentGalleryPage - 1)
    }% - ${10 * (this.currentGalleryPage - 1)}px)`;
  }
  /**
   * Redirects to the event details page with the given event id.
   * The event ID is encoded in base64 before being passed.
   * @param id The ID of the event to navigate to.
   */
  viewEvent(id: string): void {
    // Encode the event ID using base64
    const encodedId = btoa(id);
    // Call the eventId method with the encoded ID
    this.getdata.eventId(encodedId);
  }
  /**
   * Handles the form submission.
   * Validates the form and, if valid, submits the form data to the API.
   * Displays a success modal upon successful submission or an error message if the submission fails.
   */
  onSubmit() {
    // Retrieve form values
    let getform = this.incubatorForm.value;

    // Check if the form is invalid
    if (this.incubatorForm.invalid) {
      // Mark all fields as touched to show validation errors
      this.incubatorForm.markAllAsTouched();
      // Display an error notification
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Submit the form data to the API
      this.makeapi
        .method(this.saveForm, getform, 'postunauth')
        .subscribe((data) => {
          // Hide the loader
          this.getdata.amizhthLoader('hide');

          // Check if the API response is successful
          if (data.responseStatus == 'Success') {
            // Display the success modal
            document.getElementById('myModal').style.display = 'block';
            // Reset the form
            this.incubatorForm.reset();
          } else {
            // Display an error notification
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }

  /**
   * Hides the modal dialog box.
   * This method is called when the user clicks on the "OK" button of the modal dialog box.
   * It hides the modal dialog box by setting its display property to 'none'.
   */
  closeModal(): void {
    document.getElementById('myModal').style.display = 'none'; // Hide the modal
  }

  district;
  districtList;
  mapdistrict;
  valueDistrict;
  noonBording = false;
  /**
   * Method to handle the click event on the district button.
   * Fetches the district details from the API and populates the districtname and districtusers properties.
   * Also, sets the valueDistrict property to the selected district.
   * @param value The name of the district that was clicked.
   */
  mapGetBtn(value) {
    // Fetch the district details from the API
    this.map();

    // Reset the districtname and districtusers properties
    this.districtname = '';
    this.districtusers = '';

    // Set the valueDistrict property to the selected district
    this.valueDistrict = value;

    // Iterate through the district list and set the districtname and districtusers properties
    for (let i = 0; i < this.district.length; i++) {
      if (value == this.district[i].district) {
        // Set the districtname and districtusers properties to the selected district
        this.districtname = this.district[i].district;
        this.districtusers = this.district[i].users;
      } else {
        // Set the noonBording property to true and showOnLoad property to false
        this.noonBording = true;
        this.showOnLoad = false;
      }
    }
  }
  districtname;
  districtusers;
  sample;
  /**
   * Fetches the list of districts from the API and populates the district property.
   * Also, sets the districtname and districtusers properties to the first district
   * in the list.
   */
  map() {
    this.makeapi.method(this.mapGetApi, '', 'getunauth').subscribe((data) => {
      // Set the district property to the response data
      this.district = data.districtList;

      // If the district list is not empty, set the districtname and districtusers
      // properties to the first district in the list
      if (this.district['']) {
        this.districtname = this.district[0].district;
        this.districtusers = this.district[0].users;
      }
    });
  }
  /**
   * Navigates to the district details page with the given district name.
   * @param districtname The name of the district to view details for.
   */
  viewdistrict(districtname) {
    // Call the service to navigate to the district details page with the given district name
    this.getdata.district(districtname);
  }
  /**
   * Navigates to the incubator details page.
   * @param incubatorName The name of the incubator to view details for.
   */
  viewDetails(incubatorName) {
    // Call the service to navigate to the incubator details page with the given incubator name
    this.getdata.incubatorId(incubatorName);
  }

  gallerydisList: any = [];
  noData = false;
  /**
   * Fetches the list of galleries from the API based on the pagination.
   * Updates the list object with the pagination parameters and calls the galleryListApi() function
   * to refresh the list of galleries.
   */
  galleryList() {
    this.list = {
      /**
       * The number of items to fetch from the API
       */
      listSize: this.currentPageCount,
      /**
       * The page number to fetch from the API
       */
      pageNumber: this.paginationCount,
    };
    /**
     * Calls the API to fetch the list of galleries from the API
     * and updates the component data
     */
    this.galleryListApi();
  }
  /**
   * Fetches the list of galleries from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  galleryListApi() {
    this.getdata.amizhthLoader('show');
    // Call the API to fetch the list of galleries
    return this.makeapi
      .method(this.gallerylistApi, this.list, 'postunauth')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        // Check if the response contains any data
        if (data.responsemodelList != undefined) {
          // If there is data, hide the "No Data" message and update the component data
          this.noData = false;
          // Set the total number of items
          this.numberOfList = data.count;
          // Set the total number of pages
          this.totalPages = data.totalPages;
          // Set the count of items in the response
          this.countList = data.responsemodelList.length;
          // Calculate the start and end count for the current page
          if (
            this.currentPage == this.totalPages &&
            this.countList != this.numberOfList
          ) {
            this.startCount = this.startCount + this.currentPageCount;
            this.EndCount = this.numberOfList;
          } else if (this.countList == this.numberOfList) {
            this.startCount = 1;
            this.EndCount = this.numberOfList;
          }
          // Update the list of galleries
          this.gallerydisList = data.responsemodelList;
          // Set the imageData
          this.imageData = this.gallerydisList;
        } else {
          // If there is no data, show the "No Data" message
          this.noData = true;
        }
      });
  }
  imageData;
  /**
   * Calculates the total number of pages based on the count of data.
   * This function is called whenever the data count changes.
   */
  Pagination_Count() {
    // Reset the loading state
    this.loading = false;
    // Get the total count of data
    let totalcount = this.numberOfList;
    // Set the total part count to the total count
    this.totalPartCount = totalcount;
    // Calculate the total number of pages by dividing the total count by the current page count
    // and rounding up to the nearest whole number.
    this.totalPages = Math.ceil(this.totalPartCount / this.currentPageCount);
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 12;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 12;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 12;
  countList = 0;
  /**
   * Paginates the gallery list of images and updates the start and end counts
   * of the list.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page) {
    // Show the pagination controls
    this.show_page = true;

    // If the user is navigating to the previous page and is not on the first page
    if (page == 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;

      // If the user is not on the first page
      if (this.currentPage > 1) {
        // Decrement the current page number
        let prevcount = this.currentPage;
        prevcount--;
        // Update the pagination count
        this.paginationCount = prevcount;
        // Update the current page number
        this.currentPage = prevcount;
      } else {
        // If the user is on the first page, set the pagination count to 1
        this.paginationCount = 1;
      }

      // Adjust the start and end counts for the new page
      if (this.EndCount != this.numberOfList) {
        // Decrement the start count
        this.startCount = this.startCount - this.currentPageCount;
        // Decrement the end count
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // If we are at the last page, adjust the start and end counts to the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // If the user is navigating to the next page
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;

      // If the user is not on the last page
      if (this.currentPage > 1) {
        // Increment the current page number
        let nextcount = this.currentPage - 1;
        nextcount++;
        // Update the pagination count
        this.paginationCount = nextcount;
      }
      // If the user is not on the last page, update the start and end counts
      if (this.currentPage != this.totalPages) {
        // Increment the start count
        this.startCount = this.startCount + this.currentPageCount;
        // Increment the end count
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }
    // Call the galleryList method to fetch the list of images for the new page
    this.galleryList();
  }
  homeList;
  list: any = {};
  /**
   * Fetches the list of startup and accelerator data for the home page from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  homeApi() {
    this.makeapi.method(this.homelistApi, '', 'getunauth').subscribe((data) => {
      // Update the component data with the response from the API
      this.homeList = data;
    });
  }

  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
  // incubater search
  protected incubatorNameList: incub[] = [];
  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  protected _onDestroy = new Subject();
  /**
   * Sets the initial value of the incubator select control and filters the list
   * of incubators based on the user's input.
   * Subscribes to the value changes of the filter control and calls the
   * filterBanks function whenever the value changes.
   */
  filterIncubetor() {
    // Set the initial value of the incubatorName select control
    this.incubatorName.setValue(this.incubatorNameList[1]);

    // Set the initial value of the incubator list
    this.incubatorListValue.next(this.incubatorNameList.slice());

    // Subscribe to the value changes of the filter control
    this.incubatorFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        // Call the filterBanks function whenever the value of the filter control changes
        this.filterBanks();
      });
  }
  /**
   * Sets the initial value of the incubator select control.
   * Subscribes to the first value of the incubator list value and sets the compareWith
   * function of the singleSelect control to compare the incubator name strings.
   */
  protected setInitialValue() {
    this.incubatorListValue
      .pipe(
        // Take the first value of the incubator list value
        take(1),
        // Automatically unsubscribe on component destroy
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        // Compare the incubator name strings
        this.singleSelect.compareWith = (a: incub, b: incub) =>
          a && b && a.incubatorName === b.incubatorName;
      });
  }
  /**
   * Filters the list of incubator names based on a search term.
   * If no search term is provided, the full list is returned.
   */
  protected filterBanks() {
    // Get the current search term from the filter control
    let search = this.incubatorFilterCtrl.value;

    if (!search) {
      // If no search term is provided, return the full list of incubator names
      this.incubatorListValue.next(this.incubatorNameList.slice());
    } else {
      // Convert the search term to lowercase for case-insensitive comparison
      search = search.toLowerCase();
    }

    // Filter the incubator name list based on the search term and update the list value
    this.incubatorListValue.next(
      this.incubatorNameList.filter(
        (val) => val.incubatorName.toLowerCase().indexOf(search) > -1
      )
    );
  }
  searchValue = false;
  searchList = [];
  /**
   * Called when the user selects an incubator from the dropdown list.
   * @param value The value of the selected incubator.
   */
  selectIncubator(value) {
    // Set the search value to true
    this.searchValue = true;

    // Reset the search list
    this.searchList = [];

    // Get the value of the incubator form
    let getform = this.incubatorForm.value;

    // Set the list object to the selected incubator
    this.list = {
      incubatorName: getform.incubator,
    };

    // Call the List API
    this.ListApi();
  }
  /**
   * Scroll to the element with the given id.
   * @param sectionId The id of the element to scroll to.
   */
  scrollTo(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      // Smooth scroll to the element
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
